<template>
    <div class="footer">
        <div class="container mx">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <p>Copyyright &copy; {{ year }} at Dewhot.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
    data() {
        return {
            year: new Date().getFullYear()
        };
    }
};
</script>
<style scoped></style>
